import { PageShell } from "../components/layout/PageShell";
import { LEGAL_DOCS } from "../data/legal";

export default function PolicyPage({ docKey }) {
  const doc = LEGAL_DOCS[docKey];
  if (!doc) return null;
  return (
    <PageShell testId={`policy-${docKey}`} overline={doc.overline} title={doc.title} intro={doc.intro} path={`/${docKey}`}>
      <div className="space-y-10">
        {doc.sections.map((s, i) => (
          <section key={i} data-testid={`policy-section-${i}`}>
            <h2 className="font-serif text-2xl text-brand-charcoal">{s.heading}</h2>
            <div className="mt-4 space-y-4 text-sm leading-relaxed text-brand-stone">
              {s.body.map((p, j) => (
                <p key={j}>{p}</p>
              ))}
            </div>
          </section>
        ))}
        <p className="border-t border-brand-sand pt-6 text-xs uppercase tracking-[0.18em] text-brand-stone/70" data-testid="policy-updated">
          {doc.updated}
        </p>
      </div>
    </PageShell>
  );
}
